import { TABS_BASE_CLASSNAME, createTabs } from '@vfde-brix/ws10/tabs';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { debugInfo } from '../util/debug';

export const mountAllTabs = () => {
    try {
        for (const tabsEl of document.getElementsByClassName(TABS_BASE_CLASSNAME)) {
            const wrapperEl = tabsEl.parentElement;

            wrapperEl && createTabs(wrapperEl, NO_PATTERN_BUSINESS_LOGIC);
        }
    } catch (error) {
        debugInfo('WS10 tabs mount failed: ', error);
    }
};
